import { useCallback, useState } from "react";
import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { CommercialInfo, CommercialInfoInput } from "@/interfaces/talk2pay.iterfaces";
import t2payService from "@/services/t2pay.service";

export const useGetCommercialInfo = () => {
  const { data = null, isLoading, error, mutate } = useSWR<CommercialInfo, Error>(
    SWR_KEYS.getCommercialInfo,
    () => t2payService.getCommercialInfo(),
    { revalidateOnFocus: false }
  );
  return { data, isLoading, error, mutate };
};

export const useUpdateCommercialInfo = () => {
  const [isLoading, setIsLoading] = useState(false);
  const update = useCallback(async (payload: CommercialInfoInput) => {
    setIsLoading(true);
    try {
      return await t2payService.updateCommercialInfo(payload);
    } finally {
      setIsLoading(false);
    }
  }, []);
  return { update, isLoading };
};
